// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__C7oJr","top-border-table":"Table_top-border-table__bt2AI","comparison-table":"Table_comparison-table__Gcrpu"};